// @ts-ignore Allow unused imports
import * as Types from '../../graphql/schema';

import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
export type ChatbotEligibilityQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type ChatbotEligibilityQuery = { __typename: 'Query', advisor?:
    | { __typename: 'InstitutionalAdvisor' }
    | { __typename: 'PremiumAdvisor' }
   | null };


export const ChatbotEligibilityDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ChatbotEligibility"},"directives":[{"kind":"Directive","name":{"kind":"Name","value":"operationServiceConfig"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"feature"},"value":{"kind":"StringValue","value":"chatbot","block":false}}]}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"advisor"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}}]}}]}}]} as unknown as DocumentNode<ChatbotEligibilityQuery, ChatbotEligibilityQueryVariables>;